import React from "react";
import {
  MDBContainer,
  MDBInput,
  MDBCol,
  MDBRow,
  MDBSwitch,
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody
} from "mdb-react-ui-kit";

import "./AccountNewModal.css";

import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import ParticipationEditor from "../ParticipationEditor/ParticipationEditor";

export class AccountNewModal extends React.Component {
  constructor(props) {
    super(props);

    let userDataJson = sessionStorage.getItem("userData");
    let userData = userDataJson ? JSON.parse(userDataJson) : {};

    let dataDefault = {
      IDCuenta: null,
      nombre: "",
      activo: 1,
      tipo: "PERSONAL"
    };

    this.state = {
      showAccountNewModal: this.props.showAccountNewModal,
      data: dataDefault,
      enabled: true,
      participaciones: [
        {
          tipo: "SSO",
          IDUsuario: userData.IDUsuario,
          nombre: userData.apodo || userData.nombre || "Yo",
          participacion: 100,
        },
      ],
      usuariosCCON: [],
    };
  }

  componentDidMount() {
    this.getUsuariosCCON();
  }

  async getUsuariosCCON() {
    await doFetch("CCON", "getUsuariosCCON", null)
      .then((response) => response.json())
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          this.setState({ usuariosCCON: data.DATA || [] });
        }
      })
      .catch(() => {});
  }

  closeModal() {
    this.props.onCloseModal();
  }

  closeModalStable = () => this.props.onCloseModal();

  handleChange(event) {
    let data = this.state.data;

    switch (event.target.id) {
      case "enabled":
        data["activo"] = this.state.enabled ? 0 : 1;
        this.setState(data);
        this.setState({enabled: !this.state.enabled});
        break;
      default:
        data[event.target.id] = event.target.value;
        this.setState(data);
        break;
    }
  }

  async doSave(event) {
    event.preventDefault();

    let res = await this.insertAccount();

    if (res) {
      this.props.onCloseModal();
    }
  }

  async insertAccount() {
    let result = false;

    this.props.onLoading(true);

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        cuenta: this.state.data,
        participaciones: this.state.participaciones,
      }),
    };

    await doFetch("CCON", "insertAccountWithParticipations", requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          result = true;
        }
      })
      .catch((error) => {
        console.error(
          "Error al obtener datos:",
          JSON.stringify(error, null, 2)
        );
      })
      .finally(() => {
        this.props.onLoading(false);
      });

    return result;
  }

  setShow(event) {
    if (this.state.showAccountNewModal !== event) {
      if (!event) {
        this.props.onCloseModal();
      }
    }
  }

  render() {
    return (
      <>
        <MDBModal
          show={this.state.showAccountNewModal}
          onHide={this.closeModalStable}
          tabIndex="-1"
        >
          <MDBModalDialog size="lg">
            <MDBModalContent>
              <MDBModalHeader>
                <MDBModalTitle>Nueva cuenta</MDBModalTitle>
                <MDBBtn
                  className="btn-close"
                  color="none"
                  onClick={() => this.closeModal()}
                ></MDBBtn>
              </MDBModalHeader>
              <MDBModalBody>
                <MDBContainer breakpoint="sm">
                  <MDBRow>
                    <MDBCol size="8">
                      <MDBInput
                        className="mb-4"
                        type="text"
                        id="nombre"
                        label="Nombre de cuenta"
                        value={this.state.data.nombre}
                        onChange={(event) => this.handleChange(event)}
                      />
                    </MDBCol>
                    <MDBCol size="2">
                      <select
                        id="tipo"
                        className="form-select mb-4"
                        value={this.state.data.tipo}
                        onChange={(event) => this.handleChange(event)}
                      >
                        <option value="PERSONAL">Personal</option>
                        <option value="SHARED_EXPENSE">Gastos compartidos</option>
                        <option value="BUDGET">Presupuesto</option>
                      </select>
                    </MDBCol>
                    <MDBCol size="2">
                      <MDBSwitch
                        id="enabled"
                        label="Activo"
                        checked={this.state.enabled}
                        onChange={(event) => this.handleChange(event)}
                      />
                    </MDBCol>
                  </MDBRow>
                  <MDBRow>
                    <MDBCol size="12">
                      <label className="form-label">Participantes</label>
                      <ParticipationEditor
                        participaciones={this.state.participaciones}
                        usuariosCCON={this.state.usuariosCCON}
                        onChange={(p) => this.setState({ participaciones: p })}
                        onLoading={(v) => this.props.onLoading(v)}
                      />
                    </MDBCol>
                  </MDBRow>
                  <MDBBtn className="mt-3" onClick={(event) => this.doSave(event)} block>
                    Guardar
                  </MDBBtn>
                </MDBContainer>
              </MDBModalBody>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>
      </>
    );
  }
}
